import React, {useState} from "react";
import {Collapse} from "react-bootstrap";
import {PiCaretDown, PiCaretRight} from "react-icons/pi";

function anzeigewert(wert) {
    if (wert === null || wert === undefined || wert === "") {
        return <span className="text-muted">–</span>;
    }
    if (typeof wert === "boolean") {
        return wert ? "Ja" : "Nein";
    }
    if (typeof wert === "object") {
        return <code className="small">{JSON.stringify(wert)}</code>;
    }
    return String(wert);
}

/**
 * Vorher/Nachher einer Datenänderung, je Zeile aufklappbar - die Änderung
 * selbst kommt als {feld: {alt, neu}} (Spezifikation Abschnitt 4,
 * activity_changes.changes). Zugeklappt nur eine kurze Zusammenfassung
 * ("3 Felder geändert"), damit die Tabelle bei vielen Zeilen nicht sofort
 * überladen wirkt.
 */
export default function NutzungAenderungDetails({changes}) {
    const [offen, setOffen] = useState(false);
    const felder = changes && typeof changes === "object" ? Object.entries(changes) : [];

    if (felder.length === 0) {
        return <span className="text-muted small">–</span>;
    }

    return (
        <div>
            <button
                type="button"
                className="btn btn-link btn-sm text-decoration-none px-0 d-inline-flex align-items-center gap-1"
                onClick={() => setOffen((v) => !v)}
                aria-expanded={offen}
            >
                {offen ? <PiCaretDown aria-hidden="true" /> : <PiCaretRight aria-hidden="true" />}
                {felder.length} {felder.length === 1 ? "Feld geändert" : "Felder geändert"}
            </button>
            <Collapse in={offen}>
                <div>
                    <table className="table table-sm table-borderless mb-0 mt-1" style={{maxWidth: 520}}>
                        <thead>
                            <tr className="text-muted small">
                                <th className="fw-normal">Feld</th>
                                <th className="fw-normal">Vorher</th>
                                <th className="fw-normal">Nachher</th>
                            </tr>
                        </thead>
                        <tbody>
                            {felder.map(([feld, wert]) => (
                                <tr key={feld}>
                                    <td className="small text-nowrap">{feld}</td>
                                    <td className="small">{anzeigewert(wert?.alt)}</td>
                                    <td className="small">{anzeigewert(wert?.neu)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Collapse>
        </div>
    );
}
